import * as React from "react";
import { useProductData, useCLDeliveryIndicatorConfig, useCLEcommContext } from "@grandvisionhq/fun-products";
import { DeliveryIndicator } from "@grandvisionhq/shipping";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
const DeliveryIndicatorGraphContainer = ({
  deliveryResolverFactory,
  requiredRxNotFilledIn
}) => {
  const { getLabel } = useIntl();
  const { isDeliveryFullDateEnabled } = useFeatureToggles();
  const { activeVariant, product } = useProductData();
  const channels = React.useMemo(() => {
    const channels2 = {};
    if (!activeVariant?.inventoryChannels) return channels2;
    for (const channel of activeVariant.inventoryChannels) {
      channels2[channel.id] = {
        availableQuantity: channel.quantity
      };
    }
    return channels2;
  }, [activeVariant.inventoryChannels]);
  const deliveryResolver = !!deliveryResolverFactory ? deliveryResolverFactory([product], product.productType) : void 0;
  if (activeVariant.isExcludedFromCheckout || isDeliveryFullDateEnabled) {
    return null;
  }
  let availability = [{ channels }];
  let fallbackLabel = void 0;
  if (requiredRxNotFilledIn) {
    availability = void 0;
    fallbackLabel = getLabel("products.deliveryIndicator.selectPrescription");
  }
  return /* @__PURE__ */ React.createElement(
    DeliveryIndicator,
    {
      availability,
      deliveryResolver,
      fallbackLabel,
      view: "usp"
    }
  );
};
const DeliveryIndicatorCLGraphContainer = ({ deliveryResolverFactory }) => {
  const { hasConfiguredLineItems } = useCLDeliveryIndicatorConfig();
  const { state, selectors } = useCLEcommContext();
  const stockStatus = selectors.getSelectedPrescriptionStockStatus(state);
  const deliveryResolverFactoryWithStockStatus = React.useMemo(() => {
    if (!deliveryResolverFactory) return void 0;
    return (products, productType) => {
      return deliveryResolverFactory(products, productType, stockStatus);
    };
  }, [deliveryResolverFactory, stockStatus]);
  return /* @__PURE__ */ React.createElement(
    DeliveryIndicatorGraphContainer,
    {
      deliveryResolverFactory: deliveryResolverFactoryWithStockStatus,
      requiredRxNotFilledIn: !hasConfiguredLineItems
    }
  );
};
export {
  DeliveryIndicatorCLGraphContainer,
  DeliveryIndicatorGraphContainer
};
//# sourceMappingURL=DeliveryIndicatorGraphContainer.js.map
